enum Languages {
  CATALAN = 'ca',
  ENGLISH = 'en',
  SPANISH = 'es',
  ORIGINAL = 'qaa',
}

export default Languages;
